/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  STATUS_CODE_SUCCESS,
  STATUS_CODE_CREATE_SUCCESS,
} from '../../../constants/StatusCode'
import { PortfoliosApi } from '../../../client-axios/api'
import { axiosInstance } from '../../../core/axios'
import { configHeader } from '../../../core/token'
import { Dispatch } from 'redux'
import {
  GET_BY_ID_PORTFOLIO_SUCCESS,
  GET_BY_ID_PORTFOLIO_ERROR,
  GET_BY_ID_PORTFOLIO,
  CREATE_PORTFOLIO_SUCCESS,
  CREATE_PORTFOLIO_ERROR,
  UPDATE_PORTFOLIO_ERROR,
  UPDATE_PORTFOLIO_SUCCESS,
  GET_PORTFOLIO_BY_ACCOUNT_ID_SUCCESS,
  UPDATE_PORTFOLIO,
  GET_LIST_PORTFOLIO,
  GET_LIST_PORTFOLIO_SUCCESS,
  UPDATE_PORTFOLIO_HOLDING_SUCCESS,
  UPDATE_PORTFOLIO_HOLDING_ERROR,
  GET_PORTFOLIO_BY_ACCOUNT_ID_AT_SUCCESS,
} from '../../../constants/ActionTypes'
import { PortfolioItem } from '../../../dto'
import { capitalizeFirstLetter } from '../../../util/function'
import { showMessage } from '../../../util/showMessage'

export const getListPortfolio = (): unknown => (dispatch: Dispatch) => {
  dispatch({ type: GET_LIST_PORTFOLIO })
  const portfoliosApi = new PortfoliosApi(
    configHeader(),
    undefined,
    axiosInstance
  )
  portfoliosApi.findAllWithPortfolios().then((res) => {
    if (res?.status === STATUS_CODE_SUCCESS) {
      dispatch({ type: GET_LIST_PORTFOLIO_SUCCESS, data: res.data })
    } else {
      return res
    }
  })
}

export const createPortfolio =
  (payload: PortfolioItem): unknown =>
  (dispatch: Dispatch) => {
    const portfoliosApi = new PortfoliosApi(
      configHeader(),
      undefined,
      axiosInstance
    )

    return portfoliosApi
      .createWithPortfolios(payload)
      .then((res) => {
        if (res.status === STATUS_CODE_CREATE_SUCCESS) {
          dispatch({ type: CREATE_PORTFOLIO_SUCCESS, payload: res.data })
          return res?.status
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: CREATE_PORTFOLIO_ERROR,
            error: error.response?.data?.detail?.message,
          })
          showMessage('error' ,capitalizeFirstLetter(error.response?.data?.detail?.message.replace(/_/g, ' ')))
        }
        return error?.response?.statusCode
      })
  }

export const updatePortfolio =
  (payload: { id: any; data: PortfolioItem }): unknown =>
  (dispatch: Dispatch) => {
    const portfoliosApi = new PortfoliosApi(
      configHeader(),
      undefined,
      axiosInstance
    )
    dispatch({ type: UPDATE_PORTFOLIO })
    return portfoliosApi
      .updateWithPortfolios(payload.id, payload.data)
      .then((res) => {
        if (res?.status === STATUS_CODE_SUCCESS) {
          dispatch({ type: UPDATE_PORTFOLIO_SUCCESS, payload: res.data })
        }
        return res?.status
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: UPDATE_PORTFOLIO_ERROR,
            error: error.response?.data?.detail?.message,
          })
          showMessage('error' ,capitalizeFirstLetter(error.response?.data?.detail?.message.replace(/_/g, ' ')))
        }
        return error?.response?.statusCode
      })
  }

export const getPortfolioById =
  (payload: { id: any }): unknown =>
  (dispatch: Dispatch) => {
    const portfoliosApi = new PortfoliosApi(
      configHeader(),
      undefined,
      axiosInstance
    )
    dispatch({ type: GET_BY_ID_PORTFOLIO })
    return portfoliosApi
      .findOneWithPortfolios(payload.id)
      .then((res) => {
        if (res?.status === STATUS_CODE_SUCCESS) {
          dispatch({ type: GET_BY_ID_PORTFOLIO_SUCCESS, payload: res?.data })
        }
      })
      .catch((error) => {
        dispatch({
          type: GET_BY_ID_PORTFOLIO_ERROR,
          error: error.response?.data?.message,
        })
      })
  }

/**
 * Redux を経由せず、ポートフォリオ一覧だけ取得したいとき用の API
 */
export async function fetchPortfoliosByAccountId(
  accountId: number
): Promise<PortfolioItem[] | undefined> {
  const portfoliosApi = new PortfoliosApi(
    configHeader(),
    undefined,
    axiosInstance
  )
  try {
    const res = await portfoliosApi.findAllByAccountIdWithPortfolios(
      accountId
    )
    if (res?.status === STATUS_CODE_SUCCESS) {
      return res.data as PortfolioItem[]
    }
    return undefined
  } catch (error: unknown) {
    const axiosErr = error as {
      response?: { data?: { detail?: { message?: string }; message?: string } }
    }
    if (axiosErr?.response) {
      const msg =
        axiosErr.response?.data?.detail?.message ??
        axiosErr.response?.data?.message
      if (msg) {
        showMessage(
          'error',
          capitalizeFirstLetter(String(msg).replace(/_/g, ' '))
        )
      }
    }
    return undefined
  }
}

/** API で取った一覧を portList / portListAT に載せる（API は呼ばない） */
export function putPortfoliosInStore(
  dispatch: Dispatch,
  data: PortfolioItem[]
): void {
  dispatch({ type: GET_PORTFOLIO_BY_ACCOUNT_ID_SUCCESS, data })
  dispatch({ type: GET_PORTFOLIO_BY_ACCOUNT_ID_AT_SUCCESS, data })
}

export const getPortfolioByAccountId =
  (payload: any): unknown =>
  (dispatch: Dispatch) => {
    const portfoliosApi = new PortfoliosApi(
      configHeader(),
      undefined,
      axiosInstance
    )
    return portfoliosApi
      .findAllByAccountIdWithPortfolios(payload.accountId)
      .then((res) => {
        if (res?.status === STATUS_CODE_SUCCESS) {
          dispatch({
            type: GET_PORTFOLIO_BY_ACCOUNT_ID_SUCCESS,
            data: res?.data,
          })
          dispatch({
            type: GET_PORTFOLIO_BY_ACCOUNT_ID_AT_SUCCESS,
            data: res?.data,
          })
        }
      })
  }
export const updateHoldings =
  (payload: any): unknown =>
  (dispatch: Dispatch) => {
    const portfoliosApi = new PortfoliosApi(
      configHeader(),
      undefined,
      axiosInstance
    )
    return portfoliosApi
      .updateHoldingWithPortfolios(payload.id, payload.data)
      .then((res) => {
        if (res?.status === STATUS_CODE_SUCCESS) {
          dispatch({
            type: UPDATE_PORTFOLIO_HOLDING_SUCCESS,
            payload: res?.data,
          })
          return res?.status
        }
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_PORTFOLIO_HOLDING_ERROR,
          error: error.response?.data?.message,
        })
      })
  }
